var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "#F66524",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0533 24.0002C13.3788 24.0002 14.4533 22.9257 14.4533 21.6002C14.4533 20.2747 13.3788 19.2002 12.0533 19.2002C10.7278 19.2002 9.65332 20.2747 9.65332 21.6002C9.65332 22.9257 10.7278 24.0002 12.0533 24.0002Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1064 24.0002C21.4319 24.0002 22.5064 22.9257 22.5064 21.6002C22.5064 20.2747 21.4319 19.2002 20.1064 19.2002C18.7809 19.2002 17.7064 20.2747 17.7064 21.6002C17.7064 22.9257 18.7809 24.0002 20.1064 24.0002Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799998 1.60005H4.13615L7.99843 15.1207L7.6955 15.7266C6.89785 17.3202 8.05576 19.2 9.84237 19.2H23.3066C23.7488 19.2 24.1066 18.8422 24.1066 18.4C24.1066 17.9578 23.7488 17.6 23.3066 17.6H9.84237C9.24829 17.6 8.86003 16.9745 9.12675 16.4422L9.34787 16H23.3066C23.6636 16 23.9777 15.7633 24.0761 15.4195L27.2761 4.21956C27.3449 3.97817 27.2965 3.71876 27.1457 3.51802C26.9941 3.31802 26.7574 3.20004 26.5066 3.20004H6.25721L5.50878 0.580478C5.41033 0.236746 5.0963 0 4.73924 0H0.799998C0.357812 0 0 0.357812 0 0.799998C0 1.24218 0.357812 1.60005 0.799998 1.60005Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCart);
export default __webpack_public_path__ + "static/media/IconCart.7f07ba47b2f836bc7398d50195e5a053.svg";
export { ForwardRef as ReactComponent };